// extracted by mini-css-extract-plugin
module.exports = {"root":"n_p1","wrapper":"n_p2","image":"n_p3 h_dq h_ds h_dQ","crop":"n_p4","round":"n_p5","fixedHeight":"n_p6"};